function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { filterProps } from '../utils';
import { FormatError } from 'intl-messageformat';
import { ReactIntlError } from '../error';
var LIST_FORMAT_OPTIONS = ['localeMatcher', 'type', 'style'];
var now = Date.now();

function generateToken(i) {
  return "".concat(now, "_").concat(i, "_").concat(now);
}

export function formatList(_ref, getListFormat, values) {
  var locale = _ref.locale,
      onError = _ref.onError;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var ListFormat = Intl.ListFormat;

  if (!ListFormat) {
    onError(new FormatError("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", "MISSING_INTL_API"
    /* MISSING_INTL_API */
    ));
  }

  var filteredOptions = filterProps(options, LIST_FORMAT_OPTIONS);

  try {
    var richValues = {};
    var serializedValues = values.map(function (v, i) {
      if (_typeof(v) === 'object') {
        var id = generateToken(i);
        richValues[id] = v;
        return id;
      }

      return String(v);
    });

    if (!Object.keys(richValues).length) {
      return getListFormat(locale, filteredOptions).format(serializedValues);
    }

    var parts = getListFormat(locale, filteredOptions).formatToParts(serializedValues);
    return parts.reduce(function (all, el) {
      var val = el.value;

      if (richValues[val]) {
        all.push(richValues[val]);
      } else if (typeof all[all.length - 1] === 'string') {
        all[all.length - 1] += val;
      } else {
        all.push(val);
      }

      return all;
    }, []);
  } catch (e) {
    onError(new ReactIntlError("FORMAT_ERROR"
    /* FORMAT_ERROR */
    , 'Error formatting list.', e));
  }

  return values;
}